/**
 * Promo System Constants and Types
 */

// localStorage key for promo state
export var PROMO_STORAGE_KEY = 'syarah_promo_dropoff';
export var TEMP_PROMO_FOR_TRACKING_KEY = 'syarah_promo_temp_tracking';

// Routes that trigger drop-off detection
export var DROP_OFF_ROUTES = ['/cardetail', '/pre-checkout', '/checkout', '/payment', '/booking', '/purchase'];

// Routes that should not show promo code (conversion routes)
export var CONVERSION_ROUTES_FOR_OTHER_POSTS = ['/pre-checkout', '/checkout', '/payment', '/booking', '/purchase'];

// Routes that should clear promo code (successful conversion)
export var PROMO_CLEAR_ROUTES = ['/payedsuccess'];

// Timing constants
export var FIRST_SHOW_DELAY = 5000; // 5 seconds delay for first-time popup

// Promo display modes
export var DISPLAY_MODES = {
  NONE: 'none',
  POPUP: 'popup',
  BUTTON: 'button',
  TAG: 'tag'
};

// Promo interaction types

// Page context types

// Display configuration

// Promo eligibility reasons
export var ELIGIBILITY_REASONS = {
  INITIALIZING: 'Initializing...',
  NO_PROMO: 'No promo code available',
  EXPIRED: 'Promo code expired',
  USER_CLOSED: 'Promo was closed by user',
  API_CLOSED: 'Promo was already shown/closed',
  DROP_OFF_BUTTON: 'On promo post after drop-off (button mode)',
  DROP_OFF_POPUP: 'Drop-off recovery mode (popup mode)',
  ON_PROMO_POST: 'User is on promo post page',
  ON_SHOP_APPLY: 'User is on shop-apply page for this promo',
  NOT_ELIGIBLE: 'Not eligible - no matching conditions',
  ERROR: 'Error occurred'
};